// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApprovalComponentMasterService = {};

ApprovalComponentMasterService.getApprovalComponentMasterService = function (
  data
) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/approvalComponentMaster/search?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&id=" +
      data?.id +
      "&description=" +
      data?.description,
    method: "get",
  });
};

ApprovalComponentMasterService.postApprovalComponentMaster = function (data) {
  return lossClient({
    url: `/ApprovalComponentMaster/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApprovalComponentMasterService.putApprovalComponentMaster = function (data) {
  return lossClient({
    url: `/ApprovalComponentMaster/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

ApprovalComponentMasterService.deleteApprovalComponentMaster = function (data) {
  return lossClient({
    url: `/ApprovalComponentMaster/delete`,
    method: "delete",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

export default ApprovalComponentMasterService;
